import { gql } from "utils/urql";
import { formatArticleDate } from "utils/date";
import { HomepageAuthorFragment, HomepageMetadataFragment } from "types/api";
import Authors from "components/Authors";
import styles from "./HomepageMetadata.module.scss";

const AuthorWrapper = ({
  url,
  displayName,
  analyticsSection,
  riverIndex,
}: HomepageAuthorFragment & {
  analyticsSection: string;
  riverIndex?: number;
}) => {
  return (
    <a
      href={url}
      className={styles.author}
      data-action={`click link - ${analyticsSection} - author${
        riverIndex ? ` ${riverIndex}` : ""
      }`}
    >
      {displayName}
    </a>
  );
};

const HomepageMetadata = ({
  authors,
  datePublished,
  analyticsSection,
  riverIndex,
}: Omit<HomepageMetadataFragment, "__typename"> & {
  analyticsSection: string;
  riverIndex?: number;
}) => {
  return (
    <div className={styles.root}>
      {authors.length > 0 && (
        <div className={styles.byline}>
          <Authors
            authors={authors}
            component={AuthorWrapper}
            analyticsSection={analyticsSection}
            riverIndex={riverIndex}
          />
        </div>
      )}
      {datePublished && (
        <time className={styles.datePublished} dateTime={datePublished}>
          {formatArticleDate(datePublished)}
        </time>
      )}
    </div>
  );
};

HomepageMetadata.fragment = gql`
  fragment homepageAuthor on Author {
    id
    url
    displayName
  }

  fragment homepageMetadata on PromoItem {
    datePublished
    authors {
      ...homepageAuthor
    }
  }
`;

export default HomepageMetadata;
